const baseUrlMap = {
  localhost: myTWBackendUrlDev,
  "dev.non-prod.my.thoughtworks.net": myTWBackendUrlDev,
  "stage.non-prod.my.thoughtworks.net": myTWBackendUrlStage,
  "my.thoughtworks.net": myTWBackendUrl,
};

export function getBackendApiUrl() {
  return baseUrlMap[window.location.hostname];
}
